import { render } from "./AdminHomeNav.vue?vue&type=template&id=3ec03b81"
import script from "./AdminHomeNav.vue?vue&type=script&lang=js"
export * from "./AdminHomeNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__